// @flow

import { css, keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(36,164,127, 0.4);
    box-shadow: 0 0 0 0 rgba(36,164,127, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(36,164,127, 0);
      box-shadow: 0 0 0 10px rgba(36,164,127, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(36,164,127, 0);
      box-shadow: 0 0 0 0 rgba(36,164,127, 0);
  }
`;

const PulseAnimation = css`
  animation: ${pulse} 1s infinite;
`;

export default PulseAnimation;
